import axios from 'axios'

const favorites = {
  add (username, query, category, tags, cb) {
    const promise = axios.post('https://api.psyco.fr/cafe/favorites',
      { 'username': username,
        'payload': {
          'query': query,
          'category': category,
          'tags': tags,
        },
      },
      {'headers': 
        {'Authorization': 'orbbisyourgod'},
      },
    )
    this.handleRequest(promise, cb)
  },

  edit (username, data, cb) {
    const promise = axios.patch('https://api.psyco.fr/cafe/favorites',
      { 'username': username,
        'payload': data,
      },
      {'headers':
        {'Authorization': 'orbbisyourgod'},
      },
    )
    this.handleRequest(promise, cb)
  },

  delete (username, id, cb) {
    const promise = axios.post('https://api.psyco.fr/cafe/favorites/delete',
      { 'username': username,
        'id': id,
      },
      {'headers':
        {'Authorization': 'orbbisyourgod'},
      },
    )
    this.handleRequest(promise, cb)
  },

  toggle (username, id, cb) {
    const promise = axios.post('https://api.psyco.fr/cafe/favorites/toggle',
      { 'username': username,
        'id': id,
      },
      {'headers':
        {'Authorization': 'orbbisyourgod'},
      },
    )
    this.handleRequest(promise, cb)
  },

  fetch (cb) {
    const promise = axios.get('https://api.psyco.fr/cafe/favorites', 
      {
        params: {username: localStorage.getItem('username')},
        headers: {'Authorization': 'orbbisyourgod'},
      },
    )
    this.handleResults(promise, cb)
  },

  handleResults(promise, cb) {
    promise.then((resp) => {
      if (resp.data.code && resp.data.code !== 200) {
        cb([])
      }
      else {
        cb(resp.data.data)
      }
    }).catch((error) => cb([]))
  },

  handleRequest (promise, cb) {
    promise.then((resp) => {
      cb(true)
    }).catch((error) => cb(false))
  },
}

export default favorites
